import { useState } from "react"
import { useAuthContext } from "./useAuthContext"
import { useNavigate } from "react-router-dom"


export const useLogin = () => {
    const [isLoading, setIsLoading] = useState(null)
    const [error, setError] = useState(null)
    const { dispatch } = useAuthContext()
    const navigate = useNavigate()

    const login = async(email, password) => {
        setError(null)
        setIsLoading(true)
        const response = await fetch('https://myrestaurantmz3699-junaidedmehroz3699.b4a.run/api/user/login', {
            method: 'POST',
            headers: {'Content-type': 'application/json'},
            body : JSON.stringify({ email, password})
        })
        
        const data = await response.json()

        if(!response.ok) {
            setIsLoading(false)
            setError(data.error)
        }
        if(response.ok) {
            localStorage.setItem('user', JSON.stringify(data))

            //authContext
            dispatch({type : 'LOGIN', payload: data})

            setIsLoading(false)
            navigate('/')
        }
    }
    return { login, isLoading, error}
}

export default useLogin